/* eslint-disable no-throw-literal */
import {
  GET_HOLDPLACE_PRODUCTS,
  GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT,
  GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT_EDIT,
  UPDATE_CONSUMABLE_ITEM_SHOP_STOCK_COUNT
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_HOLDPLACE_PRODUCTS] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/shop_consumable_items/get_hold_place_products', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT] ({ dispatch }, params) {
      const res = await dispatch('apiGet', {
        url: '/master/shop_consumable_items/get_consumable_item_shop_stock_count',
        data: {consumable_item_id: params.consumable_item_id}
      })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT_EDIT] ({ dispatch }, params) {
      const res = await dispatch('apiGet', {
        url: '/master/shop_consumable_items/get_consumable_item_shop_stock_count_edit',
        data: {consumable_item_id: params.consumable_item_id, shop_id: params.shop_id}
      })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_CONSUMABLE_ITEM_SHOP_STOCK_COUNT] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/shop_consumable_items/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-consumable-items.js